import { useState } from 'react';
import ReactDOM from 'react-dom';

import useWindowSize from '../../hooks/useWindowSize';
import MapRouter, { Tab } from '../MapRouter';
import { getLeadStateByPractitioner } from '../../helpers/lead';
import { store } from "stores/Store";

import styles from './MapRouterWithDetails.module.scss';
import BaseballCard, { Tab as BaseballCardTab } from '../PractitionerBaseballCard';

interface IMapRouterProps {
  setSelectedView: (view: string) => void;
  tab?: Tab;
  setShowUnsavedChangesModal: (show: boolean) => void;
  showUnsavedChangesModal: boolean;
  hasRouteChanged: boolean;
  setHasRouteChanged: (hasRouteChanged: boolean) => void;
  isDesktopMap?: boolean;
}

/**
 * This version is capable of displaying the baseball card in a portal. It's meant to be used outside of the map view.
 */
const MapRouterWithDetails = ({
  setSelectedView,
  tab = Tab.CURRENT_ROUTE,
  setShowUnsavedChangesModal,
  showUnsavedChangesModal,
  hasRouteChanged,
  setHasRouteChanged,
  isDesktopMap = false,
}: IMapRouterProps) => {
  const [isIdentificationCardModalOpen, setIsIdentificationCardModalOpen] = useState(false);
  const { width, height } = useWindowSize();

  return (
    <>
      <MapRouter
        hasRouteChanged={hasRouteChanged}
        isDesktopMap={isDesktopMap}
        setHasRouteChanged={setHasRouteChanged}
        setSelectedView={setSelectedView}
        setShowUnsavedChangesModal={setShowUnsavedChangesModal}
        showUnsavedChangesModal={showUnsavedChangesModal}
        tab={tab}
        onSelectPractitioner={() => setIsIdentificationCardModalOpen(true)}
      />
      {isIdentificationCardModalOpen &&
        ReactDOM.createPortal(
          <div className={styles.baseballCardOverlay}>
            <div
              className={styles.baseballCardModal}
              style={{ borderRadius: isDesktopMap ? 0 : '40px 40px 0 0' }}
              onClick={e => e.stopPropagation()}
            >
              <div className={styles.baseballCardModalContent} style={{ width: width > 480 ? width * .6 : width * .9, height: height * .8, position: 'relative', paddingTop: "40px", }}>
                <div className={getLeadStateByPractitioner(store.currentPractitioner) ? styles["tinted-border"] : ""}>
                  {getLeadStateByPractitioner(store.currentPractitioner) && (
                    <div className={styles["top-message"]}>
                      {getLeadStateByPractitioner(store.currentPractitioner)}
                    </div>
                  )}
                </div>
                  <BaseballCard backHandler={() => setIsIdentificationCardModalOpen(false)} defaultTab={BaseballCardTab.SUMMARY} generalNotes={store.currentPractitioner.general_notes || ''} />
              </div>
            </div>
          </div>,
          document.body
        )
      }
    </>
  )
}

export default MapRouterWithDetails;
